import matches from 'validator/lib/matches';

export const isString = (v) => typeof v == 'string';

export const ssnPattern = /^(19|20)[0-9]{6}[-\s]?[0-9]{4}$/;
export const mobilePattern = /[1-9]\d{8,14}$/;
export const onlyNumericPlus = /[^0-9+]/;

const VALID_PHONE_START = [
  '070',
  '+70',
  '70',
  '+4670',
  '072',
  '72',
  '+72',
  '+4672',
  '073',
  '73',
  '+4673',
  '+73',
  '076',
  '+76',
  '76',
  '+4676',
  '079',
  '+79',
  '79',
  '+4679',
];

export function hasValidMobilePhoneNumber(phoneNumber: string): boolean {
  return (
    matches(phoneNumber, mobilePattern) &&
    !matches(phoneNumber, onlyNumericPlus) &&
    hasValidPhoneStartPrefix(phoneNumber)
  );
}

export function hasValidPhoneStartPrefix(phoneNumber: string): boolean {
  for (const prefix of VALID_PHONE_START) {
    if (phoneNumber.startsWith(prefix)) {
      return true;
    }
  }

  return false;
}
